import { Observable } from 'rxjs';
import { WalletTypeModel} from '@src/core/domain/wallet/walletType.model';

export abstract class WalletTypeRepository {
  abstract getWalletTypes(): Observable<WalletTypeModel[]>;
  abstract ConsultaObrigatoriedadeChaveAcessoNfAutbank(): Observable<any>;
}
